const STORAGE_KEY = 'firebaseToken';

type Listener = (token: string | null) => void;
const listeners = new Set<Listener>();

export const getFirebaseToken = (): string | null => {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const setFirebaseToken = (token: string | null | undefined) => {
  try {
    if (token) sessionStorage.setItem(STORAGE_KEY, token);
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Ignore storage errors (private mode, quota); listeners still fire so auth state stays consistent.
  }
  const value = token ?? null;
  listeners.forEach((cb) => {
    try {
      cb(value);
    } catch {
      // Don't let one listener break the others.
    }
  });
};

export const subscribeFirebaseToken = (cb: Listener): (() => void) => {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
};
